import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import DashboardPage from "../pages/settings/dashboard/dashboardPage";
import CheckMember from "../pages/opd/index";
import Layout from "../components/layout/layout";
import SettingLayout from "../components/layout/settingLayout";
import Index from "../pages/index";
import CreateNewOPD from "../pages/opd/create";
import PrintOPD from "../pages/opd/detail/printOPD";
import EmergencyContact from "../pages/opd/create/emergencyContact";
import Quotation from "../pages/quotation";
import Cashier from "../pages/cashier";
import UsedCourse from "../pages/usedCourse";
import JobCost from "../pages/jobCost";
import Booking from "../pages/booking";
import CreateQUO from "../pages/quotation/quotationcreate";
import Setting from "../pages/settings";
import AgencyType from "../pages/settings/agency/agencyType";
import AgencyList from "../pages/settings/agency/agencyList";
import Branches from "../pages/settings/branches/branches";
import JobGroup from "../pages/settings/job/jobGroup";
import JobPermission from "../pages/settings/job/jobPermission";
import JobTitle from "../pages/settings/job/jobTitle";
import Personnel from "../pages/settings/personnel/personnel";
import UsersGroups from "../pages/settings/personnel/usersGroups";
import Category from "../pages/settings/product/category";
import GiftVoucher from "../pages/settings/product/giftVoucher";
import Treatment from "../pages/settings/product/treatment";
import Promotion from "../pages/settings/product/promotion";
import CourseList from "../pages/usedCourse/courseList";
import PersonalHistory from "../pages/opd/detail";
import OPDSearch from "../pages/opd/detail/opdSearch";
import SO from "../pages/opd/so/so";
import OPDView from "../pages/opd/detail/opdView";
import Complication from "../pages/opd/detail/requestComplication";
import ViewComplication from "../pages/opd/detail/viewComplication";
import JOBView from "../pages/jobCost/detail/jobcostView";
import JOBDetail from "../pages/jobCost/jobcostmain1";
import NewOPD from "../pages/opd/detail/newMedicalRecord";
import UploadOPD from "../pages/opd/detail/uploadOPD";
import EditDoctor from "../pages/opd/detail/editDoctor";
import Refund from "../pages/opd/detail/refund";
import UsageLog from "../pages/opd/detail/usageLog";
import BuyCourse from "../pages/opd/so/buyCourse";
import Cart from "../pages/opd/so/cart";
import Conclusion from "../pages/opd/so/conclusion";
import SODetail from "../pages/opd/so/soDetail";
import BookingCalendar from "../pages/booking/detail/bookingcalendar";
import BookingDetail from "../pages/booking/detail/bookingdetail";
import PersonnelCreate from "../pages/settings/personnel/personnel/personnelcreate";
import PersonnelCreateNew from "../pages/settings/personnel/personnel/personnelcreateNew";
import PersonnelDetailNew from "../pages/settings/personnel/personnel/personneldetailNew";
import UsersGroupsSetting from "../pages/settings/personnel/usergroups/usersgroupssetting";
import SubCategory from "../pages/settings/product/category/subcategory";
import JobGroupCategory from "../pages/settings/product/jobGroupCategory/jobGroupCategory";

import PromotionCreate from "../pages/settings/product/promotion/promotioncreate";
import PromotionView from "../pages/settings/product/promotion/promotionView";

import StockCategory from "../pages/settings/stock/category";
import CreateStock from "../pages/settings/stock/createStock";
import AddStock from "../pages/settings/stock/addStock";
import StockCreateProduct from "../pages/settings/stock/addStock/createProduct";
import RequestStock from "../pages/settings/stock/requestStock";
import JobCreate from "../pages/settings/job/jobgroup/create";
import DetailCashier from "../pages/cashier/detailCashier";
import GiftVoucherCreate from "../pages/settings/product/giftvoucher/giftvouchercate";
import GiftVoucherEdit from "../pages/settings/product/giftvoucher/giftvoucheredit";
import GiftVoucherPrint from "../pages/settings/product/giftvoucher/giftvoucherprint";

import Payments from "../pages/settings/payments/payments";

import PaymentRecord from "../pages/cashier/payment/paymentRecord";
import PaymentHistory from "../pages/cashier/payment/paymentHistory";
import HistoryDetail from "../pages/cashier/payment/historyDetail";
import CashierInvoice from "../pages/cashier/invoice";
import CashierInvoiceHistory from "../pages/cashier/invoiceHistory";
import TaxHistory from "../pages/cashier/taxHistory";
import ReceiptHistory from "../pages/cashier/receiptHistory";
import ReceiptPayDepositHistory from "../pages/cashier/receiptPayDepositHistory";

import TreatmentCreate from "../pages/settings/product/treatment/treatmentcreate";
import AgencyMember from "../pages/settings/agency/agencylist/member";
import BranchesCategory from "../pages/settings/branches/branchescategory";
import BranchesEdit from "../pages/settings/branches/branchesedit";
import BranchesRoom from "../pages/settings/branches/branchesroom";
import BranchesMedical from "../pages/settings/branches/branchmedical";
import JobCostView from "../pages/jobCost/jobcostmain";
import JobCostPrint from "../pages/jobCost/jobcostprint";

import CourseListPro from "../pages/usedCourse/coursedetail/courseListPro";
import CourseListPro1 from "../pages/usedCourse/coursedetail/courseListPro1";
import CourseList1 from "../pages/usedCourse/coursedetail/courseList1";
import Courserenew from "../pages/usedCourse/coursedetail/courserenew";
import Courserenew1 from "../pages/usedCourse/coursedetail/courserenew1";
import Creategift from "../pages/usedCourse/coursedetail/creategift";
import CourseProList1 from "../pages/usedCourse/coursedetail/courseProList1";
import CourseProrenew from "../pages/usedCourse/coursedetail/courseProrenew";
import CourseProrenew1 from "../pages/usedCourse/coursedetail/courseProrenew1";

import InventoryCategory from "../pages/settings/inventory/category";
import InventoryLocation from "../pages/settings/inventory/location";
import Supplier from "../pages/settings/inventory/supplier";
import InventoryManagement from "../pages/settings/inventory/management";
import InventoryAddProduct from "../pages/settings/inventory/AddProduct";
import InventoryPr from "../pages/settings/inventory/pr";
import InventoryPrCreate from "../pages/settings/inventory/prCreate";
import InventoryPo from "../pages/settings/inventory/po";
import InventoryReceivePo from "../pages/settings/inventory/receivePo";
import InventoryReceiveNoPo from "../pages/settings/inventory/receiveNoPo";
import InventoryReceivePoEdit from "../pages/settings/inventory/receivePoEdit";
import InventoryReceiveNoPoCreate from "../pages/settings/inventory/receiveNoPoCreate";
import InventoryPoCreate from "../pages/settings/inventory/poCreate";
import InventoryReplyList from "../pages/settings/inventory/replyList";
import InventoryRequestList from "../pages/settings/inventory/requestList";
import RequestCreate from "../pages/settings/inventory/requestCreate";
import ReplyApprover from "../pages/settings/inventory/replyApprover";


import StockRequest from "../pages/settings/stock/requestStock/stockRequest";
import StockRequestWithDraw from "../pages/settings/stock/requestStock/stockRequest1";

import SystemLog from "../pages/settings/systemlog";
import BartherVat from "../pages/settings/product/barthervat";

import MedicalEquipment from "../pages/settings/medicalequipment/medicalequipment";

import ViewForm from "../pages/quotation/quotationreceipt";

import Login from "../pages/login/loginPage";
import Logout from "../pages/logout";
import ForgotPassword from "../pages/forgotpassword/fogotpassword";
import SendEmail from "../pages/forgotpassword/sendEmail";
import CreateNewPassword from "../pages/forgotpassword/createnewpassword";

import Viplist from "../pages/settings/viplist/viplist";
import PrintLabelDrugs from "../pages/opd/detail/printLabelDrugs";

import Notification from "../pages/notification";

import OtherUnit from "../pages/settings/other/unit";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          <Login />
        </Route>
        <Route path="/logout" exact>
          <Logout />
        </Route>
        <Route path="/home">
          <Layout noHeader={true}>
            <Index />
          </Layout>
        </Route>

        {/*-------------------- forgotpassword -----------------------------------------------------------*/}
        <Route path="/forgotpassword" exact>
          <ForgotPassword />
        </Route>
        <Route path="/forgotpassword/sendEmail" exact>
          <SendEmail />
        </Route>
        <Route path="/recover/forgot-password" exact>
          <CreateNewPassword />
        </Route>

        {/*-------------------- opd -----------------------------------------------------------*/}
        <Route path="/opd" exact>
          <Layout firstPage={true}>
            <CheckMember />
          </Layout>
        </Route>
        <Route path="/opd/create/:id" exact>
          <Layout>
            <CreateNewOPD />
          </Layout>
        </Route>
        <Route path="/opd/print/:id" exact>
          <Layout>
            <PrintOPD />
          </Layout>
        </Route>
        <Route path="/opd/printLabelDrugs/:id" exact>
          <Layout>
            <PrintLabelDrugs />
          </Layout>
        </Route>
        <Route path="/opd/create/:id/emergency-contact" exact>
          <Layout>
            <EmergencyContact />
          </Layout>
        </Route>
        <Route path="/opd/list/:id/" exact>
          <Layout>
            <PersonalHistory />
          </Layout>
        </Route>
        <Route path="/opd/list/:type/:id/create-opd" exact>
          <Layout>
            <NewOPD />
          </Layout>
        </Route>

        <Route path="/opd/list/:id/view" exact>
          <Layout>
            <OPDView />
          </Layout>
        </Route>
        <Route path="/opd/list/:id/view/refund" exact>
          <Layout>
            <Refund />
          </Layout>
        </Route>

        <Route path="/opd/list/:id/view/complication/:courseRecordId" exact>
          <Layout>
            <Complication />
          </Layout>
        </Route>
        <Route path="/opd/list/:id/view/usage-log/:id" exact>
          <Layout>
            <UsageLog />
          </Layout>
        </Route>

        <Route path="/opd/list/:id/view/opd/:id" exact>
          <Layout>
            <UploadOPD />
          </Layout>
        </Route>
        <Route path="/opd/list/:id/view/edit-doctor/:id" exact>
          <Layout>
            <EditDoctor />
          </Layout>
        </Route>

        <Route path="/opd/list/:id/view/view-complication/" exact>
          <Layout>
            <ViewComplication />
          </Layout>
        </Route>

        <Route path="/opd/search/:searchText" exact>
          <Layout>
            <OPDSearch />
          </Layout>
        </Route>
        {/*-------------------- so -----------------------------------------------------------*/}
        <Route path="/opd/so/:id" exact>
          <Layout>
            <SO />
          </Layout>
        </Route>
        <Route path="/opd/so-detail/:id/:idmember" exact>
          <Layout>
            <SODetail />
          </Layout>
        </Route>

        <Route path="/opd/so/buy/:id" exact>
          <Layout>
            <BuyCourse />
          </Layout>
        </Route>
        <Route path="/opd/so/cart/:id" exact>
          <Layout>
            <Cart />
          </Layout>
        </Route>
        <Route path="/opd/so/conclusion/:id" exact>
          <Layout>
            <Conclusion />
          </Layout>
        </Route>

        {/*-------------------- cashier -----------------------------------------------------------*/}
        <Route path="/cashier" exact>
          <Layout>
            <Cashier />
          </Layout>
        </Route>
        <Route path="/cashier/:id" exact>
          <Layout>
            <DetailCashier />
          </Layout>
        </Route>
        <Route path="/cashier/:id/payment" exact>
          <Layout>
            <PaymentRecord />
          </Layout>
        </Route>
        <Route path="/cashier/:id/invoice" exact>
          <Layout>
            <CashierInvoice />
          </Layout>
        </Route>
        <Route path="/cashier/:id/history" exact>
          <Layout>
            <PaymentHistory />
          </Layout>
        </Route>
        <Route path="/cashier/:id/invoice/history" exact>
          <Layout>
            <CashierInvoiceHistory />
          </Layout>
        </Route>
        <Route path="/cashier/:id/:payment/tax/history" exact>
          <Layout>
            <TaxHistory />
          </Layout>
        </Route>
        <Route path="/cashier/:id/:payment/receipt" exact>
          <Layout>
            <ReceiptHistory />
          </Layout>
        </Route>
        <Route path="/cashier/:id/:payment/receiptPayDeposit" exact>
          <Layout>
            <ReceiptPayDepositHistory />
          </Layout>
        </Route>
        <Route path="/cashier/:id/:payment/history/detail" exact>
          <Layout>
            {/* <DetailCashier /> */}
            <HistoryDetail />
          </Layout>
        </Route>
        <Route path="/cashier/:id/:approval" exact>
          <Layout>
            <DetailCashier />
          </Layout>
        </Route>
        {/*-------------------- usedcourse -----------------------------------------------------------*/}
        <Route path="/usedcourse" exact>
          <Layout>
            <UsedCourse />
          </Layout>
        </Route>
        <Route path="/usedcourse/:id" exact>
          <Layout>
            <CourseList />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id" exact>
          <Layout>
            <CourseListPro />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courseListPro1" exact>
          <Layout>
            <CourseListPro1 />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courseList1" exact>
          <Layout>
            <CourseList1 />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courserenew" exact>
          <Layout>
            <Courserenew />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courserenew1" exact>
          <Layout>
            <Courserenew1 />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/creategift" exact>
          <Layout>
            <Creategift />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courseProList1" exact>
          <Layout>
            <CourseProList1 />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courseProrenew" exact>
          <Layout>
            <CourseProrenew />
          </Layout>
        </Route>
        <Route path="/usedcourse/coursedetail/:id/courseProrenew1" exact>
          <Layout>
            <CourseProrenew1 />
          </Layout>
        </Route>
        {/* ------------------------------------------------ job cost ------------------------------- */}
        <Route path="/jobcost" exact>
          <Layout>
            <JobCost />
          </Layout>
        </Route>
        <Route path="/jobcost/:id" exact>
          <Layout>
            <JOBView />
          </Layout>
        </Route>
        <Route path="/jobcost/list/:id/view" exact>
          <Layout>
            <JOBDetail />
          </Layout>
        </Route>
        <Route path="/jobcost/view/:id/jobcost" exact>
          <Layout>
            <JobCostView />
          </Layout>
        </Route>
        <Route path="/jobcost/view/:id" exact>
          <Layout>
            <JobCostPrint />
          </Layout>
        </Route>
        {/* ----------------------------------------- booking ----------------------------------------------------------- */}
        <Route path="/booking" exact>
          <Layout>
            <Booking />
          </Layout>
        </Route>
        <Route path="/booking/list/:id/view" exact>
          <Layout>
            <BookingCalendar />
          </Layout>
        </Route>
        <Route path="/booking/calendar/:id/view" exact>
          <Layout>
            <BookingDetail />
          </Layout>
        </Route>
        {/* --------------------------------------------------- quotation ------------------------------------------------- */}
        <Route path="/quotation" exact>
          <Layout>
            <Quotation />
          </Layout>
        </Route>
        <Route path="/quotation/create/" exact>
          <Layout>
            <CreateQUO />
          </Layout>
        </Route>
        <Route path="/quotation/detail/:id/print" exact>
          <Layout>
            <ViewForm />
          </Layout>
        </Route>
        {/* ------------------------------------------------------ setting --------------------------------------------------- */}
        <Route path="/setting" exact>
          <SettingLayout noHeader={true}>
            <Setting />
          </SettingLayout>
        </Route>
        <Route path="/setting/personnel" exact>
          <SettingLayout title="PERSONNEL">
            <Personnel />
          </SettingLayout>
        </Route>
        <Route path="/setting/usersgroups" exact>
          <SettingLayout title="USERS GROUPS">
            <UsersGroups />
          </SettingLayout>
        </Route>
        <Route path="/setting/usersgroups/list/:id/usersgroupssetting" exact>
          <SettingLayout title="USERS GROUPS / SETTING">
            <UsersGroupsSetting />
          </SettingLayout>
        </Route>
        <Route path="/setting/personnel/personnelcreate" exact>
          <SettingLayout title="CREATE PERSONNEL">
            <PersonnelCreate />
          </SettingLayout>
        </Route>

        <Route path="/setting/personnel/list/:id/personnelcreate" exact>
          <SettingLayout title="CREATE PERSONNEL">
            <PersonnelCreate />
          </SettingLayout>
        </Route>
        <Route path="/setting/personnel/personnelcreateNew" exact>
          <SettingLayout title="CREATE PERSONNEL">
            <PersonnelCreateNew />
          </SettingLayout>
        </Route>
        <Route path="/setting/personnel/:id/personneldetailNew" exact>
          <SettingLayout title="CREATE PERSONNEL">
            <PersonnelDetailNew />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/category" exact>
          <SettingLayout title="CATEGORY">
            <Category />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/category/list/:id/subcategory" exact>
          <SettingLayout title="CATEGORY / SUBCATEGORY">
            <SubCategory />
          </SettingLayout>
        </Route>

        <Route path="/setting/service/category/list/:id/jobGroupCategory" exact>
          <SettingLayout title="Job Group / HAIR">
            <JobGroupCategory />
          </SettingLayout>
        </Route>

        <Route path="/setting/service/treatment" exact>
          <SettingLayout title="Treatment">
            <Treatment />
          </SettingLayout>
        </Route>

        <Route path="/setting/service/treatment/treatmentcreate/:id" exact>
          <SettingLayout title="TREATMENT / CREATE">
            <TreatmentCreate />
          </SettingLayout>
        </Route>

        <Route path="/setting/service/promotion" exact>
          <SettingLayout title="PROMOTION">
            <Promotion />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/promotion/promotioncreate" exact>
          <SettingLayout title="PROMOTION / CREATE">
            <PromotionCreate />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/promotion/:id/view" exact>
          <SettingLayout title="PROMOTION / EDIT">
            <PromotionCreate />
          </SettingLayout>
        </Route>
        {/* <Route path="/setting/service/promotion/:id/view" exact>
          <SettingLayout title="PROMOTION / CREATE">
            <PromotionView />
          </SettingLayout>
        </Route> */}
        <Route path="/setting/service/giftvoucher" exact>
          <SettingLayout title="GIFT VOUCHER">
            <GiftVoucher />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/giftvoucher/giftvouchercate" exact>
          <SettingLayout title="GIFT VOUCHER">
            <GiftVoucherCreate />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/giftvoucher/giftvoucherprint" exact>
          <SettingLayout title="">
            <GiftVoucherPrint />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/giftvoucher/:id" exact>
          <SettingLayout title="GIFT VOUCHER">
            <GiftVoucherEdit />
          </SettingLayout>
        </Route>
        <Route path="/setting/service/barthervat" exact>
          <SettingLayout title="BARTHER (VAT)">
            <BartherVat />
          </SettingLayout>
        </Route>
        <Route path="/setting/job/title" exact>
          <SettingLayout title="JOB TITLE">
            <JobTitle />
          </SettingLayout>
        </Route>
        <Route path="/setting/job/group" exact>
          <SettingLayout title="JOB GROUP">
            <JobGroup />
          </SettingLayout>
        </Route>
        <Route path="/setting/job/permission" exact>
          <SettingLayout title="JOB PERMISSION">
            <JobPermission />
          </SettingLayout>
        </Route>
        <Route path="/setting/agency/type" exact>
          <SettingLayout title="AGENCY TYPE">
            <AgencyType />
          </SettingLayout>
        </Route>
        <Route path="/setting/agency/list" exact>
          <SettingLayout title="AGENCY LIST">
            <AgencyList />
          </SettingLayout>
        </Route>
        <Route path="/setting/branches" exact>
          <SettingLayout title="BRANCHES">
            <Branches />
          </SettingLayout>
        </Route>
        <Route path="/setting/branches/create" exact>
          <SettingLayout title="BRANCHES / CATEGORY">
            <BranchesCategory />
          </SettingLayout>
        </Route>
        <Route path="/setting/branches/:id/edit" exact>
          <SettingLayout title="BRANCHES / เอกมัย สำนักวานใหญ่">
            <BranchesEdit />
          </SettingLayout>
        </Route>
        <Route path="/setting/branches/:id/viewroom" exact>
          <SettingLayout title="BRANCHES / ROOM">
            <BranchesRoom />
          </SettingLayout>
        </Route>
        <Route path="/setting/branches/:id/viewmedical" exact>
          <SettingLayout title="BRANCHES / MEDICAL EQUIPMENT">
            <BranchesMedical />
          </SettingLayout>
        </Route>

        <Route path="/setting/inventory/category" exact>
          <SettingLayout title="INVENTORY Category">
            <InventoryCategory />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/location" exact>
          <SettingLayout title="INVENTORY LOCATION">
            <InventoryLocation />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/supplier" exact>
          <SettingLayout title="Supplier">
            <Supplier />
          </SettingLayout>
        </Route>

        
        <Route path="/setting/inventory/management" exact>
          <SettingLayout title="INVENTORY MANAGEMENT">
            <InventoryManagement />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/AddProduct" exact>
          <SettingLayout title="Inventory Management/Add Product">
            <InventoryAddProduct />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/management/product/:id/" exact>
          <SettingLayout title="Inventory Management/Edit Product">
            <InventoryAddProduct />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/pr" exact>
          <SettingLayout title="PR Order">
            <InventoryPr />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/prCreate/:id" exact>
          <SettingLayout title="PR PrCreate">
            <InventoryPrCreate />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/po" exact>
          <SettingLayout title="PO Order">
            <InventoryPo />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/poApprove/:id" exact>
          <SettingLayout title="PO PrCreate">
            <InventoryPoCreate />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/receivePo" exact>
          <SettingLayout title="Receive Po">
            <InventoryReceivePo />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/receivePo/:id" exact>
          <SettingLayout title="Receive Po">
            <InventoryReceivePoEdit />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/reply" exact>
          <SettingLayout title="Reply">
            <InventoryReplyList />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/reply/:id" exact>
          <SettingLayout title="Reply">
            <ReplyApprover />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/request" exact>
          <SettingLayout title="Request">
            <InventoryRequestList />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/request/:id/:mode" exact>
          <SettingLayout title="Request">
            <RequestCreate />
          </SettingLayout>
        </Route>

        <Route path="/setting/inventory/receiveNoPo" exact>
          <SettingLayout title="Receive No Po">
            <InventoryReceiveNoPo />
          </SettingLayout>
        </Route>
        <Route path="/setting/inventory/receiveNoPo/:id" exact>
          <SettingLayout title="ReceiveNoPo Create">
            <InventoryReceiveNoPoCreate />
          </SettingLayout>
        </Route>

        <Route path="/setting/stock/category" exact>
          <SettingLayout title="STOCK CATEGORY">
            <StockCategory />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/createStock" exact>
          <SettingLayout title="CREATE STOCK">
            <CreateStock />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/addStock" exact>
          <SettingLayout title="ADD STOCK">
            <AddStock />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/addStock/createProduct" exact>
          <SettingLayout title="STOCK / CREATE PRODUCT">
            <StockCreateProduct />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/addStock/:id/createProduct" exact>
          <SettingLayout title="STOCK / CREATE PRODUCT">
            <StockCreateProduct />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/requestStock" exact>
          <SettingLayout title="REQUEST">
            <RequestStock />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/requestStock/stockRequest" exact>
          <SettingLayout title="STOCK / CREATE PRODUCT">
            <StockRequest />
          </SettingLayout>
        </Route>
        <Route path="/setting/stock/requestStock/:id/stockRequest" exact>
          <SettingLayout title="STOCK / CREATE PRODUCT">
            <StockRequest />
          </SettingLayout>
        </Route>
        <Route
          path="/setting/stock/requestStock/:id/stockRequestWithDraw"
          exact
        >
          <SettingLayout title="STOCK / CREATE PRODUCT">
            <StockRequestWithDraw />
          </SettingLayout>
        </Route>
        <Route path="/setting/job/group/:id/create" exact>
          <SettingLayout title="JOB GROUP / CREATE">
            <JobCreate />
          </SettingLayout>
        </Route>
        <Route path="/setting/agency/list/:id/member" exact>
          <SettingLayout title="AGENCY MEMBER">
            <AgencyMember />
          </SettingLayout>
        </Route>
        <Route path="/setting/dashboard" exact>
          <SettingLayout title="DASHBOARD & REPORT">
            <DashboardPage />
          </SettingLayout>
        </Route>
        <Route path="/setting/systemlog" exact>
          <SettingLayout title="SYSTEM LOG">
            <SystemLog />
          </SettingLayout>
        </Route>
        <Route path="/setting/medicalequipment" exact>
          <SettingLayout title="">
            <MedicalEquipment />
          </SettingLayout>
        </Route>
        <Route path="/setting/viplist" exact>
          <SettingLayout title="VIP LIST">
            <Viplist />
          </SettingLayout>
        </Route>
        <Route path="/setting/payment" exact>
          <SettingLayout title="PAYMENT& PAY IN">
            <Payments />
          </SettingLayout>
        </Route>
        <Route path="/setting/other/unit" exact>
          <SettingLayout title="OTHER UNIT">
            <OtherUnit />
          </SettingLayout>
        </Route>

        <Route path="/notification" exact>
          <Layout>
            <Notification />
          </Layout>
        </Route>
      </Switch>
    </Router>
  );
};
export default Routes;
